import Flickity from "flickity";

const TestimonialSlider = (slides) => {
    // Initialization

    // Wrapper for the slider (which is used to initiate the pause function)
    var sliderWrapper = document.querySelector(".testimonial-slider__slides");

    // Count Individual Slide(s)
    var slideCount = sliderWrapper.querySelectorAll(
        ".testimonial-slider__slide"
    );

    // Slides great than 1
    var hasMultipleSlides = slideCount.length > 1;

    if (hasMultipleSlides) {
        var flkty = new Flickity(slides, {
            draggable: true,
            fade: true,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: false,
            pauseAutoPlayOnHover: true,
            pageDots: hasMultipleSlides ? true : false,
        });
    }

    // Pause control
    var isPaused = false;

    sliderWrapper.addEventListener("mouseenter", function () {
        isPaused = true;
    });

    sliderWrapper.addEventListener("mouseleave", function () {
        isPaused = false;
    });
};

export default TestimonialSlider;
